var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3B82F6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.6937 8 13.5812 8.83438 13.1719 10H12C10.8969 10 10 10.8969 10 12V22C10 23.1031 10.8969 24 12 24H20C21.1031 24 22 23.1031 22 22V12C22 10.8969 21.1031 10 20 10H18.8281C18.4187 8.83438 17.3063 8 16 8ZM16 10C16.5519 10 17 10.4481 17 11C17 11.5519 16.5519 12 16 12C15.4481 12 15 11.5519 15 11C15 10.4481 15.4481 10 16 10ZM12.25 16.5C12.25 16.0861 12.5861 15.75 13 15.75C13.4139 15.75 13.75 16.0861 13.75 16.5C13.75 16.9139 13.4139 17.25 13 17.25C12.5861 17.25 12.25 16.9139 12.25 16.5ZM15.5 16H19.5C19.775 16 20 16.225 20 16.5Cnan nan 19.775 17 19.5 17H15.5C15.225 17 15 16.775 15 16.5Cnan nan 15.225 16 15.5 16ZM12.25 19.5C12.25 19.0861 12.5861 18.75 13 18.75C13.4139 18.75 13.75 19.0861 13.75 19.5C13.75 19.9139 13.4139 20.25 13 20.25C12.5861 20.25 12.25 19.9139 12.25 19.5ZM15 19.5C15 19.225 15.225 19 15.5 19H19.5C19.775 19 20 19.225 20 19.5Cnan nan 19.775 20 19.5 20H15.5C15.225 20 15 19.775 15 19.5Z",
    fill: "#60A5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.0282f56c9644b5a9fd22899272d233ae.svg";
export { ForwardRef as ReactComponent };